import { useTranslation } from 'react-i18next'

import { FormatPrice, Text } from '@reveni-io/reveni-ui'

import { refundMethodExtraLabels } from '@/returns/constants'

import * as Styles from './styles'

const RefundMethodExtraAmount = ({ refundMethod, amount, currency }) => {
  const { t } = useTranslation()

  const label = refundMethodExtraLabels[refundMethod]

  if (!label || !amount) return null

  return (
    <Styles.Container>
      <Text type="bodySBold">{t(label)}</Text>
      <Text type="bodyMBold">
        <FormatPrice currency={currency}>{amount}</FormatPrice>
      </Text>
    </Styles.Container>
  )
}

export default RefundMethodExtraAmount
